import React from 'react'
import { CardHeader, Heading, Text, Flex, Image } from 'vvs-uikit'
import { Token } from 'vvs-sdk'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { TokenPairImage } from 'components/TokenImage'

const Wrapper = styled(CardHeader)`
  background: linear-gradient(89.96deg, #3acecd 50.12%, #5557f4 99.83%);
  border-radius: ${({ theme }) => `${theme.radii.card} ${theme.radii.card} 0 0`};
  padding: 12px 24px;
`
const StyledTokenPairImage = styled(TokenPairImage)`
  > div {
    width: 42px;
    top: 50%;
    margin-top: -21px;
    bottom: auto;
  }
`
const StyledVvsBarCardHeader: React.FC<{
  earningToken: Token
  stakingToken: Token
  isVault?: boolean
}> = ({ earningToken, stakingToken, isVault }) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex flexDirection="column">
          <Heading color="black" scale="md">
            {isVault ? t('xVVS Vault') : t('Get xVVS')}
          </Heading>
          <Text color="black" small mt={1}>
            {isVault ? t('Lock your xVVS into a vault to earn extra VVS') : t('Stake VVS to receive xVVS')}
          </Text>
        </Flex>
        {isVault ? (
          <Image alt="vault icon" src="/images/xVVS/xvvs-vault-icon.png" width={64} height={56} mt={2} />
        ) : (
          <StyledTokenPairImage primaryToken={stakingToken} secondaryToken={earningToken} width={64} height={64} />
        )}
      </Flex>
    </Wrapper>
  )
}

export default StyledVvsBarCardHeader
